












































import Component from "vue-class-component";
import { Mixins } from "vue-property-decorator";
import { EchartsMixin } from "../../../../echarts.mixin";
import { EchartsChartConfigItemMixin } from "../../echarts-chart-config-item.mixin";
import { ChartOutputMetadataObserverMixin } from "../../../../chart-output-metadata-observer.mixin";
import config from "../LegendConfig/legend-config-items";
import { BaseTemplateType } from "../../../../../../shared/types/layout-workspace/components/template-selector/enums/template-type.enum";
import { debounce } from "quasar";
import { isArray, isString } from "../../../../../utils/get-type";
import { createObjByPath } from "../../../../../utils/dynamic-object";
import { get } from "lodash";
import { EventBus } from "../../../../../bus-events/event-bus";
import { ICON_CONFIG_CHANGED_ICON } from "../../../../../bus-events/icon-config-changed-icon.event";
import { MERGE_CHART_OPTIONS } from "../../../../../store/chart-output.module/mutations/merge-chart-option.mutation";

@Component({
  components: {
    PureToggle: () => import("../../../pure-config/PureToggle.vue"),
    PureSelect: () => import("../../../pure-config/PureSelect.vue"),
    PureRadioSlide: () => import("../../../pure-config/PureRadioSlide.vue"),
  },
  mixins: [],
})
export default class EchartsPieLegendConfig extends Mixins(
  EchartsMixin,
  EchartsChartConfigItemMixin,
  ChartOutputMetadataObserverMixin,
) {
  private config = config;

  beforeCreate() {
    this.name = "echarts-legend-config";
    this.templateType = BaseTemplateType.CHART;
  }
  mounted() {
    this.$nextTick(() => {
      this.initConfigurations();
    });
  }
  beforeDestroy() {
    EventBus.$off(ICON_CONFIG_CHANGED_ICON, this.initConfigurations);
  }
  /**
   * 更新图例
   * @param {string | Array<string>} key
   * @param { any } value
   * @param { componentName } string
   * @param {boolean} updateMetadata: 初始化时， 不需要写入更新
   * @param {}
   */
  updateLegend(
    key,
    value,
    componentName,
    updateMetadata = true,
    splitIndex = -1,
  ) {
    const { metadata, echartsInstance, name, $stock } = this;
    const splitedValue = isString(value) ? value.split("-") : "";
    if (isArray(key) && splitedValue.length === key.length) {
      key.forEach((keyName, index) => {
        this.updateLegend(
          keyName,
          splitedValue[index],
          componentName,
          updateMetadata,
          index,
        );
      });
      return;
    }

    const chartOption = echartsInstance.getOption();
    let opt = {};
    if (key === "icon" && value === "self") {
      chartOption.series.forEach((series, index) => {
        const symbol = series.data[0].symbol || "circle";
        opt = createObjByPath(
          `${metadata.settings.path}/data/${index}`,
          { icon: symbol, name: series.name },
          opt,
        );
      });
    } else {
      if (key === "icon") {
        // 需要清除 legend 的 data 中的 symbol
        const data = chartOption.series[0].data
          .map(({ name, isHelpSeries }) => ({
            name,
            isHelpSeries,
          }))
          .filter(({ isHelpSeries }) => !isHelpSeries);
        opt = createObjByPath(`${metadata.settings.path}/data`, data, opt);
      }
      // 1. 生成 ECharts 的配置
      opt = createObjByPath(`${metadata.settings.path}/${key}`, value, opt);
    }
    echartsInstance.setOption(opt);
    $stock.commit(MERGE_CHART_OPTIONS, opt);

    // 更新metadata
    if (updateMetadata && componentName) {
      const path = `${name}.settings.value.${componentName}`;
      let v = value;
      const valueInMetadata = get(
        this.metadata,
        `settings.value.${componentName}`,
      );
      if (splitIndex > -1) {
        v = valueInMetadata.split("-");
        v.splice(splitIndex, 1, value);
        v = v.join("-");
      }
      this.updateMetadata(path, v);
    }
  }

  /**
   * 通过metadata更新
   */
  initConfigurations() {
    const { metadata } = this;
    const { value } = metadata.settings;
    /**
     * 有带图标的图例
     */
    const opts = this.config["legend-icon"].options;
    if (
      metadata.settings.withIcon &&
      !opts.find(({ value }) => value === "self")
    )
      opts.unshift({ label: "follow-icon-in-charts", value: "self" });

    Object.keys(value).forEach((key) => {
      if (config[key]) {
        this.$set(config[key], "model", value[key]);
        // 将数据更新到视图
        this.updateLegend(config[key].key, value[key], key, false);
      }
    });
  }

  updateLegendDebounce(key, value, name) {
    this.updateLegendDebounceHelper(this, key, value, name);
  }
  updateLegendDebounceHelper = debounce((_this, key, value, name) => {
    _this.updateLegend(key, value);
  }, 200);
}
